module.exports = __webpack_public_path__ + "static/media/icon-success.9d1c3d01.svg";